import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { NavigationList, LinkItem } from "./navigation"
import Umr from "./umr-link"
import { FooterNavigationQuery } from "../../types/graphql-types"

const Navigation: React.FC<void> = () => {
  const data: FooterNavigationQuery = useStaticQuery(
    graphql`
      query FooterNavigation {
        navigationYaml(id: { eq: "umr-footer" }) {
          ...Navigation
        }
      }
    `
  ).navigationYaml?.navigation

  let menuItemCommonClass =
    "inline-block hover:text-white sm:pt-4 sm:pb-4 mr-12 h-full w-full "
  let menuItemClass = menuItemCommonClass + " "
  return (
    <nav>
      <div class="bg-umr-blue-prm-700">
        <div class="mx-auto max-w-4xl md:max-w-6xl p-4">
          <div class="bg-umr-blue-700 text-fb12-blue-100 text-xl h-full fill-current">
            <NavigationList
              data={data}
              className="flex flex-col sm:flex-row"
              liClassName="h-24 flex content-center"
              renderItem={item => (
                <div class="w-full">
                  <LinkItem
                    item={item}
                    className={menuItemClass}
                    activeClassName={
                      menuItemCommonClass + "text-white bg-fb12-blue-350"
                    }
                    itemRenderer={item =>
                      item.label === "Philipps-Universität Marburg" ? (
                        <div class="mt-2 sm:mt-0 h-8 object-scale-down">
                            <Umr className="h-12" />
                        </div>
                      ) : (
                        <div class="h-full flex content-center items-center w-full border-t w-full border-fb12-blue-500 sm:border-none ">
                          <span class="sm:border-b border-fb12-blue-500 flex items-center sm:border-b-1 sm:border-fb12-blue-100 sm:hover:border-white">
                            <div class="">{item.label}</div>
                          </span>
                        </div>
                      )
                    }
                  />
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </nav>
  )
}

const UmrFooter: React.FC<void> = () => (
  <div>
    <Navigation />
  </div>
)

export default UmrFooter
